// src/utils/xp.ts

/** Коды дефолтных бейджей (фолбэк) */
export type BadgeCode = "starter" | "momentum" | "finisher" | "pro";

/** Фолбэк-каталог бейджей, если Directus недоступен */
export const BADGES: Array<{
  code: BadgeCode;
  label: string;
  threshold: number;
  minDay: number;
}> = [
  { code: "starter",  label: "Starter",  threshold: 30,  minDay: 3  },
  { code: "momentum", label: "Momentum", threshold: 80,  minDay: 7  },
  { code: "finisher", label: "Finisher", threshold: 140, minDay: 14 },
  { code: "pro",      label: "Pro",      threshold: 260, minDay: 26 },
];

/** Следующая цель для кольца XP — из порогов переданного каталога бейджей */
export function nextTargetFor(xp: number, thresholds: ReadonlyArray<number>): number {
  const sorted = [...thresholds].filter((t) => Number.isFinite(t) && t > 0).sort((a, b) => a - b);
  if (sorted.length === 0) return 0;
  for (const t of sorted) if (xp < t) return t;
  return sorted[sorted.length - 1];
}

/**
 * Фолбэк-вариант: проверка получения бейджа по дефолтному списку BADGES.
 * Оставляем для обратной совместимости.
 */
export function qualifyingBadge(
  xpBefore: number,
  xpAfter: number,
  dayN: number
): { code: BadgeCode; label: string } | null {
  let result: { code: BadgeCode; label: string } | null = null;
  for (const b of BADGES) {
    const crossed = xpBefore < b.threshold && xpAfter >= b.threshold;
    const dayOk = dayN >= b.minDay;
    if (crossed && dayOk) result = { code: b.code, label: b.label };
  }
  return result;
}

/**
 * Проверка получения бейджа по каталогу, пришедшему из Directus
 * (для конкретного курса).
 */
export type BadgeLike = {
  code: BadgeCode;     // системный код бейджа
  label: string;       // название
  threshold: number;   // порог XP
  minDay: number;      // минимальный день
};

export function qualifyingBadgeFrom(
  badges: ReadonlyArray<BadgeLike>,
  xpBefore: number,
  xpAfter: number,
  dayN: number
): { code: BadgeCode; label: string } | null {
  let result: { code: BadgeCode; label: string } | null = null;
  for (const b of badges) {
    const crossed = xpBefore < b.threshold && xpAfter >= b.threshold;
    const dayOk = dayN >= b.minDay;
    if (crossed && dayOk) result = { code: b.code, label: b.label };
  }
  return result;
}